export default "__VITE_ASSET__DyqRSitx__"